export default __webpack_public_path__ + "static/media/logo5.72bbc4de.png";